import React from "react";
import PropTypes from "prop-types";
import { FALLBACK_IMAGE } from "../../../../constants";
import { Link } from "@quintype/components";

import "./fallback.m.css";

const FALLBACK_IMAGE_SRC = `${FALLBACK_IMAGE}?w=640&auto=format,compress&q=80`;

const imageFallback = (fetchPriorityHigh) => {
  return (
    <div styleName="image" className="arr--fallback-image">
      <figure styleName="fallback-svg" className="arr--fallback-svg">
        <img
          className="qt-image"
          src={FALLBACK_IMAGE_SRC}
          alt="Open Magazine"
          loading="lazy"
          {...(fetchPriorityHigh ? { fetchPriority: "high" } : {})}
        />
      </figure>
    </div>
  );
};

export const FallbackImage = ({ slug, fetchPriorityHigh = false }) => {
  if (slug) {
    return (
      <Link href={slug} aria-label="image-fallback" disableAjaxLinks={true}>
        {imageFallback()}
      </Link>
    );
  } else {
    return imageFallback(fetchPriorityHigh);
  }
};

FallbackImage.propTypes = {
  slug: PropTypes.string,
  fetchPriorityHigh: PropTypes.bool,
};
